<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" @click="$emit('close')"><span class="sr_only"></span></a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('FIELD.COMMUNICATION.TITLE') }}</i>
                    </dt>
                    <dd>
                        <dl class="view_subject">
                            <dt class="subject qna_view">
                                {{ result.TITLE }}
                                <span class="in_date">{{ result.REG_DT }}</span>
                            </dt>
                        </dl>
                        <div class="view_qna_desc">
                            <dl
                                :class="'Y' === reply.ANSWERER_YN ? '' : 'reply'"
                                v-for="reply in commentList"
                                :key="pageName + reply.QUESTION_FLOW_ID + reply.COMMENT_SEQ"
                            >
                                <dt>
                                    <span class="item_status" v-if="'Y' === reply.ANSWERER_YN"
                                        >{{ $t('FIELD.EXPERT.ANSWER') }}ed by</span
                                    >
                                    <span class="item_name">{{ reply.REG_USER_NAME }}</span>
                                    <span class="item_date">{{ reply.REG_DT }}</span>
                                </dt>
                                <dd>
                                    <span v-html="getMessage(reply.MESSAGE)"></span>
                                    <span class="in_btn_wrap">
                                        <a
                                            href="javascript:"
                                            class="btn_sm_white"
                                            v-if="!isMobile()"
                                            @click="translationPop(reply.MESSAGE)"
                                        >
                                            {{ $t('FIELD.GLOBAL.TRANSLATION') }}
                                        </a>
                                    </span>
                                </dd>
                            </dl>
                            <dl class="reply_write_wrap reply" v-if="mainPopYn">
                                <dt data-input-type="textarea">
                                    <textarea class="textarea_ty w100p" maxlength="3000" v-model="comment"></textarea>
                                    <span class="textarea_counter">{{ commentLength }}/3000</span>
                                </dt>
                                <dd>
                                    <a href="javascript:" class="btn_reply" @click="replyComment('replyComment')">
                                        {{ $t('BUTTON.MYKNOWLEDGE.REPLY') }}
                                    </a>
                                </dd>
                            </dl>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import ToastGrid from '~c/ToastGrid';
import TransPopup from '~c/popup/TransPopup';

export default {
    name: 'communicationPopup',
    components: {
        'toast-grid': ToastGrid,
    },
    props: {
        param: {},
    },
    data() {
        return {
            pageName: 'communicationPopup',
            result: {},
            commentList: [],
            mainPopYn: false,
            comment: '',
            commentLength: 0,
            isMobile: SDLUtil.isMobile,
        };
    },
    mounted() {
        if (SDLUtil.isNull(this.param.userNo)) {
            this.mainPopYn = true;
        }
        this.onSearch(this.param);
    },
    watch: {
        comment() {
            this.commentLength = SDLUtil.textLength(this.comment);
        },
    },
    methods: {
        onSearch(param) {
            console.log('param', param);
            SDLUtil.showLoadingBar(true);
            return axios
                .post(`${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/communication.skp`, qs.stringify(param))
                .then(resp => {
                    for (const result of resp.data.result.rowData) {
                        this.result = result;
                    }
                    this.commentList = resp.data.commentList.rowData;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        replyComment(v) {
            if (SDLUtil.isNull(this.comment)) return;
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/questionProcessing.skp`,
                    qs.stringify({
                        questionId: this.param.questionId,
                        questionFlowId: this.param.questionFlowId,
                        comment: this.comment,
                        answererYn: 'N',
                        replyComment: v,
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.comment = '';
                    this.onSearch(this.param);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        translationPop(v) {
            let translation = '';
            if ('question' === v) {
                translation = StringUtil.removeHtmlTag(this.stripHtml(this.question.questionDesc));
            } else if ('solution' === v) {
                translation = StringUtil.removeHtmlTag(this.stripHtml(this.proSolution.ANSDESC));
            } else {
                translation = v;
            }
            SDLUtil.show(
                TransPopup,
                {
                    bodyText: translation,
                },
                { height: 'auto' },
            );
        },
        getMessage(v) {
            if (!SDLUtil.isNull(v)) {
                v = v.replace(/\n/g, '<br />');
            }

            return v;
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/communicationPopup.vue